import type { ForwardedRef } from "react";
import type { RuntimeKey } from "@/lib/model-registry";

export const PROVIDER_LABELS: Record<RuntimeKey, string> = {
  claude_cli: "Claude",
  codex_cli: "Codex",
  opencode_cli: "OpenCode",
};

export const MODEL_PICKER_CONTROL_HEIGHT = "h-8 min-h-8";
export const MODEL_PICKER_CONTROL_SHAPE = "text-appkit-caption leading-none";

export function providerGridClass(count: number): string {
  if (count >= 4) return "grid-cols-4";
  if (count === 3) return "grid-cols-3";
  if (count === 2) return "grid-cols-2";
  return "grid-cols-1";
}

export function setForwardedRef<T>(ref: ForwardedRef<T>, value: T | null) {
  if (typeof ref === "function") ref(value);
  else if (ref) ref.current = value;
}
